import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <section data-testid="not-found-page" className="mx-auto flex min-h-[70vh] max-w-7xl flex-col justify-center px-5 pt-32 pb-24 sm:px-8">
      <p className="eyebrow">404</p>
      <h1 className="mt-6 font-serif text-5xl leading-[1.02] tracking-tight sm:text-6xl lg:text-7xl">
        This page <span className="italic text-ink-soft">wandered off.</span>
      </h1>
      <Link
        to="/"
        data-testid="not-found-home-link"
        className="mt-10 inline-flex items-center gap-2 text-sm font-medium text-ink link-underline"
      >
        <ArrowLeft size={14} /> Back to the beginning
      </Link>
    </section>
  );
}
